const AboutPage = () => {
  return <div>About Page</div>;
};

export default AboutPage;
